export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://whatdoyoumeme.herokuapp.com/api';
//    'http://localhost:8080/api'; 
    //https://whatdoyoumeme.herokuapp.com/api
    // export const API_BASE_URL = process.env.NODE_ENV === 'production'
    // ? 'https://ctrl-alt-elite.herokuapp.com/api'
    // : 'http://localhost:8080/api';


// WEBPACK FOOTER //
// ./src/config.js